import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import {
	CustomerCreationType,
	CustomerDeletePathType,
	CustomerPasswordUpdatePathType,
	CustomerPasswordUpdateType,
	CustomerUpdatePathType,
	CustomerUpdateType,
} from '@schemas'

export const createCustomer = async ({
	body = {
		name: '',
		email: '',
		password: '',
	} as CustomerCreationType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/customer'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getCustomer = async ({
	query = {},
	body = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/customer'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteCustomer = async ({
	params = { customerId: '' } as CustomerDeletePathType,
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/customer/${params.customerId}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateCustomer = async ({
	params = { customerId: '' } as CustomerUpdatePathType,
	body = {
		name: '',
		email: '',
		confirmEmailNewsYn: 0,
	} as CustomerUpdateType,
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/customer/${params.customerId}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateCustomerPassword = async ({
	params = { customerId: '' } as CustomerPasswordUpdatePathType,
	body = {
		password: '',
	} as CustomerPasswordUpdateType,
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/customer/${params.customerId}/password`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const customerApi = {
	getCustomer,
	createCustomer,
	deleteCustomer,
	updateCustomer,
	updateCustomerPassword,
}

export default customerApi
